import {AppState} from "../../Redux/Types";
import {connect} from "react-redux";
import {loadUserData, setAuthFormsError} from "../../Redux/Actions";
import {bindActionCreators} from "redux";
import {JoinForm} from "../Presentation/JoinForm/JoinForm";

function mapStateToProps(state: AppState) {
    return {};
}

function mapDispatchToProps(dispatch: any) {
    return bindActionCreators({
        loadUserData,
        setAuthFormsError,
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(JoinForm);
